/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PntSegmentAdOverlayResponseDTO } from "./PntSegmentAdOverlayResponseDTO";

export type PntAppControllerGetSegmentAdOverlayByDatePathParams = {
    /**
     * @type string
    */
    slug: string;
};

export const PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum = {
    true: "true",
    false: "false"
} as const;

export type PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnumKey = (typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum)[keyof typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum];

export const PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum = {
    asc: "asc",
    desc: "desc"
} as const;

export type PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnumKey = (typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum)[keyof typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum];

export const PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum = {
    date: "date",
    brand: "brand",
    duration: "duration"
} as const;

export type PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnumKey = (typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum)[keyof typeof PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum];

export type PntAppControllerGetSegmentAdOverlayByDateQueryParams = {
    /**
     * @description From date
     * @type string
    */
    from: string;
    /**
     * @description To date
     * @type string
    */
    to: string;
    /**
     * @description Default `false`. If set to true all results will be returned, including the ones that do not have a `image_b64`
     * @type string | undefined
    */
    withResults?: PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnumKey;
    /**
     * @description Supports `asc` and `desc`
     * @type string | undefined
    */
    sortOrder?: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnumKey;
    /**
     * @description Supports sort by `date`, `brand` and `duration`
     * @type string | undefined
    */
    sortBy?: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnumKey;
};

export type PntAppControllerGetSegmentAdOverlayByDate200 = PntSegmentAdOverlayResponseDTO[];

export type PntAppControllerGetSegmentAdOverlayByDateQueryResponse = PntAppControllerGetSegmentAdOverlayByDate200;

export type PntAppControllerGetSegmentAdOverlayByDateQuery = {
    Response: PntAppControllerGetSegmentAdOverlayByDate200;
    PathParams: PntAppControllerGetSegmentAdOverlayByDatePathParams;
    QueryParams: PntAppControllerGetSegmentAdOverlayByDateQueryParams;
    Errors: any;
};